import React from 'react';
import { PiInfoLight } from 'react-icons/pi';
import { StatusPill } from 'src/modules/shared/components/atoms/status-pill';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import type { ComponentSize } from 'src/modules/shared/types/component.type';
import type {
  PropertyPublicationStatusDisplay,
  PropertyPublicationValueDisplay,
} from '../../utils/property-publication-display.util';

interface PropertyPublicationInfoBadgeProps {
  display: PropertyPublicationStatusDisplay | PropertyPublicationValueDisplay;
  size?: ComponentSize;
  className?: string;
}

export const PropertyPublicationInfoBadge: React.FC<
  PropertyPublicationInfoBadgeProps
> = ({ display, size = 'sm', className }) => {
  const { t } = useI18n();

  return (
    <StatusPill
      label={t(display.labelKey)}
      tooltip={t(display.tooltipKey)}
      variant={display.variant}
      size={size}
      className={className}
      icon={<PiInfoLight className="h-3.5 w-3.5" />}
    />
  );
};
